export default __webpack_public_path__ + "static/media/opensans.1b0809d5.ttf";